import { TypedDocumentNode, gql } from '@apollo/client';

import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

type GetGeneralTransactionsDetailsArgs = {
  transactionId: number;
};

type Asset = { id: number; name: string; iconUrl: string };
type Network = Asset & { nativeAssetCode: string };

type BankwireWithdrawal = { iban: string };
type CryptoWithdrawalRequest = {
  destinationAddress: string;
};

type Card = {
  cardExpiry: string;
  cardMask?: string;
  isSaved: boolean;
};

type CardTransaction = {
  card: Card;
};

type GeneralTransactionDetails = {
  canSave?: boolean;
  assetSupportedNetwork?: {
    network?: Network;
    asset: Asset;
  };

  transaction: {
    bankwireWithdrawal?: BankwireWithdrawal;
    cryptoWithdrawalRequest?: CryptoWithdrawalRequest;
    cardPayment?: CardTransaction;
  };
};

export type GetGeneralTransactionsDetailsResponse = {
  getGeneralTransactionDetails: DefaultApiResponse<GeneralTransactionDetails>;
};

export const getGeneralTransactionsDetailsQuery: TypedDocumentNode<
  GetGeneralTransactionsDetailsResponse,
  DefaultArg<GetGeneralTransactionsDetailsArgs>
> = gql`
  query GetGeneralTransactionDetails($record: GetTransactionDetailsRecord!) {
    getGeneralTransactionDetails(record: $record) {
      canSave
      assetSupportedNetwork {
        network {
          iconUrl
          id
          name
          nativeAssetCode
        }
        asset {
          code
          name
          iconUrl
        }
      }

      transaction {
        bankwireWithdrawal {
          iban
        }
        cardPayment {
          card {
            cardMask
            isSaved
            cardExpiry
          }
        }
        cryptoWithdrawalRequest {
          destinationAddress
        }
      }
    }
  }
`;
